<app-settings-card
  heading="SSH Keys"
  description="Füge SSH Public Keys hinzu um deinen Timer via ssh timer.jessie.ai start zu steuern."
  [showSaveButton]="false"
>
  <!-- Existing keys list -->
  @if (keys$().length > 0) {
    <ul class="mt-4 divide-y divide-gray-200">
      @for (key of keys$(); track key.id) {
        <li class="flex items-center justify-between py-3">
          <div class="min-w-0 flex-1">
            <p class="truncate text-sm font-medium text-gray-900">{{ key.data.label }}</p>
            <p class="truncate font-mono text-xs text-gray-500">
              {{ truncateFingerprint(key.data.fingerprint) }}
            </p>
            <p class="text-xs text-gray-400">
              Hinzugefügt {{ key.data.createdAt | date: 'dd.MM.yyyy' }}
            </p>
          </div>
          <button
            type="button"
            class="ml-4 text-sm text-red-600 hover:text-red-800"
            (click)="deleteKey(key)"
          >
            Löschen
          </button>
        </li>
      }
    </ul>
  } @else {
    <p class="mt-4 text-sm text-gray-500">Noch keine SSH Keys hinterlegt.</p>
  }

  <!-- Add key form -->
  @if (showAddForm()) {
    <form class="mt-4 space-y-3" [formGroup]="addForm" (ngSubmit)="submitKey()">
      <div>
        <label class="mb-1 block text-sm font-medium text-gray-700">Public Key</label>
        <textarea
          formControlName="publicKey"
          rows="3"
          placeholder="ssh-ed25519 AAAA..."
          class="w-full rounded-md border border-gray-300 px-3 py-2 font-mono text-xs focus:border-blue-500 focus:outline-none"
        ></textarea>
      </div>
      <app-text-input
        label="Bezeichnung (z.B. MacBook Pro)"
        [formControl]="addForm.controls.label"
      />
      @if (addError()) {
        <p class="text-sm text-red-600">{{ addError() }}</p>
      }
      <div class="flex gap-2">
        <button
          type="submit"
          [disabled]="isSubmitting() || addForm.invalid"
          class="rounded-md bg-blue-600 px-3 py-2 text-sm text-white hover:bg-blue-700 disabled:opacity-50"
        >
          {{ isSubmitting() ? 'Speichern...' : 'Schlüssel speichern' }}
        </button>
        <button
          type="button"
          class="rounded-md border px-3 py-2 text-sm hover:bg-gray-50"
          (click)="toggleAddForm()"
        >
          Abbrechen
        </button>
      </div>
    </form>
  } @else {
    <button
      type="button"
      class="mt-4 text-sm text-primary hover:text-blue-800 dark:hover:text-blue-400"
      (click)="toggleAddForm()"
    >
      + Schlüssel hinzufügen
    </button>
  }
</app-settings-card>
